// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3q3Q8","title":"Images90_title__1Dhfc","images":"Images90_images__3goLt"};